/**
* @file 导航跳转
* @author congpeisen@baidu.com
*/

/* globals swan, getApp */
/* eslint-disable */

import * as core from './core';
import { sendLog } from './log';
// import {
//     sendLog
// } from '../../common/js/log.js';
import { request } from '../../static/utils/request.js';
import { pay } from '../../static/utils/pay.js';
import { toLoginPage } from '../../static/utils/login.js';
import { ubcClickInit } from '../../static/utils/ubcMethods.js';

/**
 * 路由函数
 * @param {Object} conf 用户配置
 * @param {string} conf.url 跳转地址
 * @param {string} conf.type 页面打开方式
*/
/* eslint-disable fecs-camelcase */

// let app = getApp();

// 跳转
export let nav = core.throttle(({
  url = '',
  type = 'nav'
}) => {
  /* eslint-enable fecs-camelcase */
  // 映射跳转

  getApp().$api[{
    'nav': 'navigateTo',
    'redirect': 'redirectTo',
    'switch': 'switchTab',
    'relaunch': 'reLaunch',
    'back': 'navigateBack'
  }[type]]({
    url
  });
}, 500);

// 通用交互处理函数

/**
 * 通用交互函数
 * @param {Object} target      交互目标
 * @param {string} type        交互类型
 * @param {Object} vm          页面实例
 * @param {Object} config      其他配置
 * @param {String} log         日志字段
 * @param {String} logOption   日志携带参数字段
*/
export let act = ({
  target,
  type = '',
  vm,
  config,
  log,
  logOption = {},
  ext = {}
}) => {
  if (!target && !type) {
    return;
  }
  type = type.replace('m-', '');
  if (typeof log === 'string') {
    log && sendLog(log, logOption);
    log && ubcClickInit({
      page: getCurrentPages()[0] && getCurrentPages()[0].route,
      value: `${log}`,
      ext
    });
  }
  switch (type) {
    // 跳转
    case 'url':
      nav({
        url: target
      });
      break;
    // 切tab
    case 'switch':
      let urlQuery = core.getQueryObject(target);
      getApp().globalData.ts = urlQuery.ts ? urlQuery.ts : '';
      getApp().globalData.expertiseArea = urlQuery.expertiseArea ? urlQuery.expertiseArea : '';
      nav({
        url: target,
        type: 'switch'
      });
      break;
    // 调电话
    case 'call':
      getApp().$api.makePhoneCall({
        phoneNumber: target
      });
      break;
    // 异步请求
    case 'post':
      return request({
        url: target,
        data: config ? config.data : null
      }).then(res => {
        let data = res.data.data;
        if (+res.data.status === 100006) {
          getApp().$api.showToast({
            title: res.data.msg,
            icon: 'none'
          });
          return;
        }
        if (!data.jumpUrlType) {
          data.jumpUrlType = data.pay_url_type;
        }
        if (!data.jumpUrl) {
          data.jumpUrl = data.pay_url;
        }
        try {
          switch (data.jumpUrlType) {
            case 'url':
              return nav({
                url: data.jumpUrl
              });
            case 'pay':
              return pay(data.jumpUrl);
          }
          return res;
        } catch (e) {
          console.log(e);
        }
      });
    // 支付
    case 'pay':
      return pay(target, config ? config.redirect : null);
    // 跳webview
    case 'webview':
      const lvlinSids = getApp().globalData.zhishiSids || '';
      if (lvlinSids && target.includes('fctorfqim')) {
        target += `&lvlinSids=${lvlinSids}`;
      }
      window.location.href = target;
      break;
    // 打开弹层
    case 'popup':
      vm.showPopup = true; // 约定字段 showPopup、curPopupData
      target.log = log;
      vm.curPopupData = target;
      break;
    // 关闭弹层
    case 'popup-close':
      vm.showPopup = false;
      break;
    // 跳转登录
    case 'login':
      return toLoginPage(target);
    // 跳转错误页
    case 'page-error':
      getApp().$api.redirectTo({
        url: `/pages/error/index?page=${encodeURIComponent(JSON.stringify(target))}`
      });
      break;
    default:
      nav({
        url: target
      });
  }
};